/*
 * @Author: lijing
 * @Date: 2022-08-25 10:40:08
 * @Last Modified by: lijing
 * @Last Modified time: 2022-09-08 17:13:59
 */
import React, { useState, FC, useEffect } from "react";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import { VideoPreview } from "@root/components/videoPreview";
import {
  Button,
  Tree,
  Form,
  Input,
  Select,
  Row,
  Col,
  Space,
  Table,
  Modal,
  message,
} from "antd";
import { UploadVideo } from "./components/UploadVideo";
import { useSelector, useDispatch } from "react-redux";
import {
  getVideoList,
  videoInfo,
  updateVideo,
  courseVideo,
  spaceInfo
} from "@root/common/service";
import type { DirectoryTreeProps } from "antd/es/tree";
import { setVideoInfo } from "@root/reducers/video";
import { EditorCourse } from "@root/components/editorCoures/index";

const { Option } = Select;

interface DataType {
  account: string;
  applyCount: number;
  createBy: string;
  createTime: string;
  deleted: number;
  duration: number;
  durationText: string;
  fileName: string;
  fileType: string;
  id: number;
  imageUrl: string;
  instituteId: number;
  name: string;
  originalSize: number;
  source: number;
  status: number;
  statusText: string;
  subjectId: number;
  thirdCategoryId: string;
  thirdVideoId: string;
  applyStatusText: string;
  totalSize: number;
  updateTime: string;
  uploadChannel: number;
  uploadChannelText: string;
  uploadTimeText: string;
  uploadUser: number;
}

const CourseUpload: FC = () => {
  const dispatch = useDispatch();
  const [showPreview, setShowPreview] = useState(false);
  // 设置分类内容
  const { subjectData } = useSelector((state: any) => state.directionaries);
  const { siteid } = useSelector(
    (state: any) => state.videoInfo
  );
  const treeData = () => {
    const list: any = [];
    list.push({
      title: "全部",
      key: "0",
      children: [],
    });

    subjectData.forEach((item: { id: string; name: string }) => {
      list[0].children.push({
        title: item.name,
        key: `${item.id}`,
      });
    });
    return list;
  };

  const columns = [
    {
      title: "视频封面",
      dataIndex: "imageUrl",
      key: "imageUrl",
      render(_: string, data: DataType) {
        return (
          <img
            width="100%"
            src={data.imageUrl}
            alt=""
            style={{ cursor: data.status === 1 ? "unset" : "pointer" }}
            onClick={() => {
              const { thirdVideoId, thirdCategoryId } = data;
              dispatch(
                setVideoInfo({
                  vid: thirdVideoId,
                  siteid: siteid,
                  needRecord: false,
                })
              );
              setShowPreview(true);
            }}
          />
        );
      },
    },
    {
      title: "名称",
      dataIndex: "name",
      key: "name",
      render(text: string, data: any) {
        return (
          <div
            className={data.status == 1 ? "" : "videoupdate_proview"}
            onClick={() => { }}
          >
            {decodeURI(text)}
          </div>
        );
      },
    },
    {
      title: "视频时长",
      dataIndex: "durationText",
      key: "durationText",
    },
    {
      title: "已创建课程",
      dataIndex: "applyStatusText",
      key: "applyStatusText",
    },
    {
      title: "上传人",
      dataIndex: "uploadUserText",
      key: "uploadUserText",
      render(_: string, data: any) {
        return (
          <div>
            <p>{data.createBy}</p>
            <p style={{ fontSize: 12, whiteSpace: "nowrap" }}>
              {data.uploadTimeText}
            </p>
          </div>
        );
      },
    },
    {
      title: "操作",
      dataIndex: "operation",
      fixed: "right",
      render(_: string, data: any) {
        return (
          <React.Fragment>
            {data.status == 1 ? (
              <Button type="link">视频转码中</Button>
            ) : (
              <Space className="videoupdate_list_option">
                <Button
                  size="small"
                  onClick={() => {
                    onCreateClickHandle(data.thirdVideoId);
                  }}
                >
                  创建课程
                </Button>
                <Button
                  size="small"
                  onClick={() => {
                    onEditClickHandle(data);
                  }}
                >
                  编辑
                </Button>
              </Space>
            )}
          </React.Fragment>
        );
      },
    },
  ];

  const [isUploadVideoVisible, setIsUploadVideoVisible] = useState(false);
  const [isEditVideoVisible, setIsEditVideoVisible] = useState(false);
  const [treeSelect, setTreeSelect] = useState("0");
  const [videoList, setVideoList] = useState<DataType[]>([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableTotal, setTableTotal] = useState(1);
  const [tablePageNum, setTablePageNum] = useState(1);
  const [editId, setEditId] = useState<null | number>(null);
  const [isCreateCourseVisible, setIsCreateCourseVisible] = useState(false);
  const [createCourseInfo, setCreateCourse] = useState<any>(null);
  const [space, setSpace] = useState<any>(null)

  const [form] = Form.useForm();
  const [editForm] = Form.useForm();

  const onUploadClickHandle = () => {
    setIsUploadVideoVisible(true);
    // if (treeSelect === "0") {
    //   message.error("请选择分类");
    // } else {
    //   setIsUploadVideoVisible(true);
    // }
  };

  const onTreeSelect: DirectoryTreeProps["onSelect"] = (keys) => {
    setTreeSelect(keys[0] as string);
  };

  const onSearchClickHandle = () => {
    getList(1);
  };

  const onResetClickHandle = () => {
    form.resetFields();
    getList(1);
  };

  const getList = async (page = tablePageNum) => {
    // 获得空间信息
    spaceInfo().then(res => {
      setSpace(res.data);
    })

    const params = form.getFieldsValue();
    setTableLoading(true);
    setTablePageNum(page);
    getVideoList({ pageNum: page, pageSize: 10 }, { ...params })
      .then((res: any) => {
        const {
          data: { rows, total },
        } = res;
        setVideoList(rows);
        setTableTotal(total);
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  const onEditClickHandle = async (data: DataType) => {
    videoInfo(data.id).then((res) => {
      setEditId(res.data.id);
      editForm.setFieldsValue({
        name: res.data.name,
        // subjectId: res.data.subjectId,
      });
      setIsEditVideoVisible(true);
    });
  };

  const onCreateClickHandle = async (id: string) => {
    courseVideo(id).then((res) => {
      setCreateCourse(res.data);
      setIsCreateCourseVisible(true);
    });
  };

  const handleCancel = () => {
    editForm.resetFields();
    setIsEditVideoVisible(false);
  };

  const handleOk = () => {
    editForm
      .validateFields()
      .then((res: any) => {
        res.id = editId;
        res.subjectId = 1;
        updateVideo(res).then((res) => {
          message.success("修改成功");
          getList();
          handleCancel();
        });
      })
      .catch((err) => {
        message.error(err.errorFields[0].errors[0]);
      });
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className="courseupload">
      {
        space &&
        <div className="courseupload-space">
          <div className="courseupload-space-left">
            <div className="courseupload-progress">
              <div className="line"
                style={{width: `${(space.usedSpace / space.totalSpace * 100)}%`}}
              ></div>
            </div>
            <div>视频上传空间，已使用/总容量：{space.usedSpaceText}G/{space.totalSpaceText}G</div>
          </div>
        </div>
      }
      <div className="courseupload-main">
        {/* <div className="courseupload-main-left">
          <Tree
            treeData={treeData()}
            defaultExpandAll
            onSelect={onTreeSelect}
          />
        </div> */}
        <div className="courseupload-main-right">
          <Form className="courseupload-option" form={form}>
            <Row>
              <Col span={5}>
                <Form.Item name="name">
                  <Input placeholder="视频名称" />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item name="applyStatus">
                  <Select placeholder="关联课程">
                    <Option value={2}>全部</Option>
                    <Option value={1}>是</Option>
                    <Option value={0}>否</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={14}>
                <Space>
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    onClick={() => {
                      onSearchClickHandle();
                    }}
                  >
                    查询
                  </Button>
                  <Button
                    type="primary"
                    icon={<ReloadOutlined />}
                    onClick={() => {
                      onResetClickHandle();
                    }}
                  >
                    重置
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
          <div className="courseupload-upload">
            <Button
              type="primary"
              onClick={() => {
                onUploadClickHandle();
              }}
            >
              上传视频
            </Button>
          </div>
          <div className="courseupload-table">
            <Table
              dataSource={videoList}
              columns={columns as any}
              loading={tableLoading}
              rowKey={"id"}
              pagination={{
                total: tableTotal,
                onChange: (page) => {
                  getList(page);
                },
                showTotal: (total) => {
                  return "共" + total + "条记录";
                },
              }}
            />
          </div>
        </div>
      </div>
      <Modal
        title="编辑"
        visible={isEditVideoVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="courseupload-editor">
          <Form form={editForm}>
            <Form.Item name="name" label="视频名称">
              <Input />
            </Form.Item>
          </Form>
        </div>
      </Modal>
      {showPreview && <VideoPreview setVisible={setShowPreview} />}
      {isUploadVideoVisible && (
        <UploadVideo
          isUploadVideoVisible={isUploadVideoVisible}
          treeSelect={treeSelect}
          setIsUploadVideoVisible={setIsUploadVideoVisible}
          getList={getList}
        />
      )}
      {isCreateCourseVisible && (
        <EditorCourse
          courseDetail={createCourseInfo}
          setIseditorCourseVisible={setIsCreateCourseVisible}
        />
      )}
    </div>
  );
};

export default CourseUpload;
